// Added by Joe 2026-09-13

(function () {
  'use strict';

  function initSwiper(card) {
    const slides = Array.from(card.querySelectorAll('.product-card__swiper-slide'));
    if (slides.length <= 1) return;

    const dots = Array.from(card.querySelectorAll('.swiper-dot'));
    const prevBtn = card.querySelector('[data-swiper-prev]');
    const nextBtn = card.querySelector('[data-swiper-next]');

    let current = 0;
    let startX = 0;
    let isDragging = false;

    function goTo(index) {
      // Remove active from current slide
      slides[current].classList.remove('is-active');
      if (current === 0) slides[0].classList.remove('product-card__swiper-slide--first');
      if (dots[current]) dots[current].classList.remove('is-active');

      current = (index + slides.length) % slides.length;

      // Add active to new slide
      slides[current].classList.add('is-active');
      if (current === 0) slides[0].classList.add('product-card__swiper-slide--first');
      if (dots[current]) dots[current].classList.add('is-active');
    }

    // Arrow buttons
    if (prevBtn) {
      prevBtn.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        goTo(current - 1);
      });
    }

    if (nextBtn) {
      nextBtn.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        goTo(current + 1);
      });
    }

    // Touch swipe (mobile)
    card.addEventListener('touchstart', (e) => {
      startX = e.touches[0].clientX;
      isDragging = true;
    }, { passive: true });

    card.addEventListener('touchend', (e) => {
      if (!isDragging) return;
      const diff = startX - e.changedTouches[0].clientX;
      if (Math.abs(diff) > 40) {
        goTo(diff > 0 ? current + 1 : current - 1);
      }
      isDragging = false;
    }, { passive: true });

    // Mouse drag (desktop)
    card.addEventListener('mousedown', (e) => {
      startX = e.clientX;
      isDragging = true;
    });

    card.addEventListener('mouseup', (e) => {
      if (!isDragging) return;
      const diff = startX - e.clientX;
      if (Math.abs(diff) > 40) {
        goTo(diff > 0 ? current + 1 : current - 1);
      }
      isDragging = false;
    });

    card.addEventListener('mouseleave', () => {
      isDragging = false;
      // 注意：不在此处 goTo(0) —— 原实现鼠标一移开就强制回第一张，
      // 导致"点了箭头看不出变化"（复位把用户刚选的图冲掉）。改为保留用户选择。
    });

    // Prevent link navigation after drag
    card.addEventListener('click', (e) => {
      if (Math.abs(startX - e.clientX) > 10) e.preventDefault();
    });
  }

  function initAll() {
    document.querySelectorAll('[data-swiper]').forEach((card) => {
      if (!card._swiperInited) {
        card._swiperInited = true;
        initSwiper(card);
      }
    });
  }

  // Init on DOM ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  // Handle dynamically loaded cards (infinite scroll, etc.)
  const observer = new MutationObserver((mutations) => {
    mutations.forEach((m) => {
      m.addedNodes.forEach((node) => {
        if (node.nodeType !== 1) return;
        if (node.matches('[data-swiper]') && !node._swiperInited) {
          node._swiperInited = true;
          initSwiper(node);
        }
        if (node.querySelectorAll) {
          node.querySelectorAll('[data-swiper]').forEach((card) => {
            if (!card._swiperInited) {
              card._swiperInited = true;
              initSwiper(card);
            }
          });
        }
      });
    });
  });

  observer.observe(document.body, { childList: true, subtree: true });
})();
